export const formatPrice = (price: number) =>
    price.toLocaleString('en-US', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 });
